import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72db98f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CallReportForm" }
const _hoisted_2 = { class: "CallReportForm__container" }
const _hoisted_3 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-3" }, "Whatsapp", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ok_confirm = _resolveComponent("ok-confirm")!
  const _component_ok_switch = _resolveComponent("ok-switch")!
  const _component_ok_order_departure_date = _resolveComponent("ok-order-departure-date")!
  const _component_ok_checkbox = _resolveComponent("ok-checkbox")!
  const _component_ok_input = _resolveComponent("ok-input")!
  const _component_ok_select = _resolveComponent("ok-select")!
  const _component_ok_button = _resolveComponent("ok-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.is_confirming)
      ? (_openBlock(), _createBlock(_component_ok_confirm, {
          key: 0,
          onConfirm: _ctx.onConfirm,
          onCancel: _ctx.onCancel
        }, null, 8, ["onConfirm", "onCancel"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_ok_switch, {
          options: _ctx.TYPES,
          value: _ctx.type,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.type) = $event)),
          disabled: _ctx.is_loading,
          onChange: _ctx.refilterReasons
        }, null, 8, ["options", "value", "disabled", "onChange"]),
        (_ctx.isCallBack)
          ? (_openBlock(), _createBlock(_component_ok_order_departure_date, {
              key: 0,
              value: _ctx.state.date,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.date) = $event)),
              "value-validation": _ctx.state_form$.date,
              min: _ctx.dateMin,
              name: "Укажите дату",
              type: "buttons__button-orange",
              "width-full": "",
              required: ""
            }, null, 8, ["value", "value-validation", "min"]))
          : _createCommentVNode("", true),
        (_ctx.isCallBack)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_ok_checkbox, {
                class: "OkCheckbox--orange",
                checked: _ctx.state.recallForWA,
                onClick: _ctx.triggerRecallForWA
              }, null, 8, ["checked", "onClick"]),
              _hoisted_4
            ]))
          : _createCommentVNode("", true),
        (_ctx.isCallBack)
          ? (_openBlock(), _createBlock(_component_ok_input, {
              key: 2,
              name: "Укажите время",
              placeholder: "Например: 12:30",
              value: _ctx.state.time,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.time) = $event)),
              "is-invalid": _ctx.state_form$.time.$error,
              "validation-errors": _ctx.state_form$.time.$errors,
              maska: _ctx.TIME_MASK,
              required: ""
            }, null, 8, ["value", "is-invalid", "validation-errors", "maska"]))
          : _createCommentVNode("", true),
        (_ctx.isCallBack)
          ? (_openBlock(), _createBlock(_component_ok_input, {
              key: 3,
              name: "Имя",
              placeholder: "Введите имя",
              value: _ctx.state.clientName,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.clientName) = $event))
            }, null, 8, ["value"]))
          : _createCommentVNode("", true),
        (_ctx.isCallBack)
          ? (_openBlock(), _createBlock(_component_ok_input, {
              key: 4,
              name: "Номер телефона",
              placeholder: "+ 7 (777) 123 45 67",
              value: _ctx.state.phone,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.phone) = $event)),
              maska: _ctx.OKTELL_PHONE_NUMBER_MASK
            }, null, 8, ["value", "maska"]))
          : _createCommentVNode("", true),
        (!_ctx.isCallBack)
          ? (_openBlock(), _createBlock(_component_ok_select, {
              key: 5,
              value: _ctx.state.reasonId,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.reasonId) = $event)),
              name: "Выберите причину",
              placeholder: "Оборвался звонок",
              options: _ctx.reasons_state.filtered_list,
              loading: _ctx.reasons_state.is_loading,
              failed: _ctx.reasons_state.is_failed,
              "error-text": "При получении списка причин произошла ошибка",
              disabled: _ctx.is_loading || _ctx.reasons_state.is_loading,
              "is-invalid": _ctx.state_form$.reasonId.$error,
              "validation-errors": _ctx.state_form$.reasonId.$errors,
              searchable: false,
              onRefresh: _ctx.loadReasons
            }, null, 8, ["value", "options", "loading", "failed", "disabled", "is-invalid", "validation-errors", "onRefresh"]))
          : _createCommentVNode("", true),
        _createVNode(_component_ok_button, {
          class: "OkButton--orange",
          type: "button",
          loading: _ctx.is_loading,
          disabled: _ctx.is_loading,
          onClick: _ctx.onSubmit
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Сохранить ")
          ]),
          _: 1
        }, 8, ["loading", "disabled", "onClick"])
      ])
    ])
  ], 64))
}